module.exports = __webpack_public_path__ + "static/media/hiw7.6d9c5e53.svg";